/** @flow */

export const HIERARCHY_CHANGE_TYPES = {
  CREATE: "CREATE",
  DELETE: "DELETE",
  MOVE: "MOVE",
  RENAME: "RENAME",
};
